/* eslint-disable */
// @generated by protobuf-ts 2.10.0 with parameter use_proto_field_name,ts_nocheck,eslint_disable,long_type_string
// @generated from protobuf file "common/v3/generic/app_context.proto" (package "fubo.tv.proto.common.v3.generic", syntax proto2)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message fubo.tv.proto.common.v3.generic.AppContext
 */
export interface AppContext {
    /**
     * @generated from protobuf field: string app_version = 1;
     */
    app_version: string;
    /**
     * @generated from protobuf field: string player_version = 2;
     */
    player_version: string;
    /**
     * @generated from protobuf field: optional string app_id = 3;
     */
    app_id?: string;
    /**
     * @generated from protobuf field: optional string app_name = 4;
     */
    app_name?: string;
    /**
     * @generated from protobuf field: optional string client_version = 5;
     */
    client_version?: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class AppContext$Type extends MessageType<AppContext> {
    constructor() {
        super("fubo.tv.proto.common.v3.generic.AppContext", [
            { no: 1, name: "app_version", kind: "scalar", localName: "app_version", T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "1.24.1", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "App Version." } },
            { no: 2, name: "player_version", kind: "scalar", localName: "player_version", T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "1.15.3", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Player Version." } },
            { no: 3, name: "app_id", kind: "scalar", localName: "app_id", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "123", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "ID used to identify a front." } },
            { no: 4, name: "app_name", kind: "scalar", localName: "app_name", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "ios_app", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "ID used to identify a front." } },
            { no: 5, name: "client_version", kind: "scalar", localName: "client_version", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "##", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Roku Only (Fubo definition)." } }
        ]);
    }
    create(value?: PartialMessage<AppContext>): AppContext {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.app_version = "";
        message.player_version = "";
        if (value !== undefined)
            reflectionMergePartial<AppContext>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppContext): AppContext {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_version */ 1:
                    message.app_version = reader.string();
                    break;
                case /* string player_version */ 2:
                    message.player_version = reader.string();
                    break;
                case /* optional string app_id */ 3:
                    message.app_id = reader.string();
                    break;
                case /* optional string app_name */ 4:
                    message.app_name = reader.string();
                    break;
                case /* optional string client_version */ 5:
                    message.client_version = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppContext, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_version = 1; */
        if (message.app_version !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.app_version);
        /* string player_version = 2; */
        if (message.player_version !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.player_version);
        /* optional string app_id = 3; */
        if (message.app_id !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.app_id);
        /* optional string app_name = 4; */
        if (message.app_name !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.app_name);
        /* optional string client_version = 5; */
        if (message.client_version !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.client_version);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message fubo.tv.proto.common.v3.generic.AppContext
 */
export const AppContext = new AppContext$Type();
